<template>
    <div class="customizer-fallback">
        <h1>{{ title }}</h1>
        <p>{{ message }}</p>
        <a class="button" :href="homeUrl">{{ backToShopText }}</a>
    </div>
</template>

<script>
import { customizerText } from "../utils/customizerTexts";

export default {
    name: "CustomizerFallback",
    props: {
        title: {
            type: String,
            default: () => customizerText("fallbackTitle"),
        },
        message: {
            type: String,
            default: () => customizerText("fallbackMessage"),
        },
        homeUrl: {
            type: String,
            default: "/",
        },
    },
    computed: {
        backToShopText() {
            return customizerText("backToShop");
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;

.customizer-fallback {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 16px;
    width: 100%;
    padding: 32px;
    border: 1px solid $color-light-gray;
    border-radius: 24px;
    background-color: $color-white;

    h1 {
        margin: 0;
        font-size: 28px;
        line-height: 1.2;
    }

    p {
        margin: 0;
        font-size: 16px;
        line-height: 1.4;
    }

    .button {
        margin-top: 8px;
        text-decoration: none;
    }
}
</style>
